
import React, { Component } from "react";
import { useLocation } from "react-router-dom";
import { Navbar, Container, Nav, Dropdown, Button } from "react-bootstrap";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import routes from "routes.js";

var Settings = (function() {

    var setZoom = async function(value)
    {
        let zoom = localStorage.setItem("table-zoom",value);
        return zoom;
    }

    var getZoom = async function()
    {
        let zoom = localStorage.getItem("table-zoom");
        return zoom;
    }

    var getDark = async function()
    {
        let dark = localStorage.getItem("dark-mode");
        return dark;
    }

    var setDark = async function(value)
    {
        let dark = localStorage.setItem("dark-mode",value);
        return dark;
    }
    
    var checkDropDead = function (dateString)
    {
        const date = new Date(dateString);
        const now = new Date();
        if (date < now)
        {
            return "badge badge-pill badge-danger";
        }
        else
        {
            return "";
        }
    }
    

    return {
      setZoom: setZoom,
      getZoom: getZoom,
      getDark: getDark,
      setDark: setDark,
      checkDropDead: checkDropDead,
    }
  
  })();
  
  export default Settings;
